(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-photo-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('old-photo-sticky-cta')) {
    customElements.define(
      'old-photo-sticky-cta',
      class extends HTMLElement {
        connectedCallback() {
          this.showAfter = Number(this.dataset.showAfter) || 400;
          this.updateVisibility = () => {
            const visible = window.scrollY >= this.showAfter;
            this.classList.toggle('is-visible', visible);
            this.setAttribute('aria-hidden', String(!visible));
          };
          this.removeAttribute('hidden');
          this.updateVisibility();
          window.addEventListener('scroll', this.updateVisibility, { passive: true });
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.updateVisibility);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-canvas-quality"] && !Shopify.designMode) return;
  try {
    
  const CANVAS_SHOWCASE_VERSION = 'v1.2.2';
  const CANVAS_SHOWCASE_LOG_PREFIX = `🖼️ [Canvas Quality ${CANVAS_SHOWCASE_VERSION}]`;
  const canvasTiltCards = document.querySelectorAll('[data-canvas-tilt]');

  canvasTiltCards.forEach((card) => {
    let frame = 0;
    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;

    const renderTilt = () => {
      currentX += (targetX - currentX) * .14;
      currentY += (targetY - currentY) * .14;

      if (Math.abs(targetX - currentX) < .01) currentX = targetX;
      if (Math.abs(targetY - currentY) < .01) currentY = targetY;

      card.style.setProperty('--canvas-tilt-x', `${currentX.toFixed(2)}deg`);
      card.style.setProperty('--canvas-tilt-y', `${currentY.toFixed(2)}deg`);

      if (currentX !== targetX || currentY !== targetY) {
        frame = requestAnimationFrame(renderTilt);
        return;
      }

      frame = 0;
    };

    const requestTiltFrame = () => {
      if (!frame) frame = requestAnimationFrame(renderTilt);
    };

    const resetTilt = () => {
      targetX = 0;
      targetY = 0;
      requestTiltFrame();
    };

    card.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse') return;

      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;

      targetX = -y * 4;
      targetY = x * 4;
      requestTiltFrame();
    });

    card.addEventListener('pointerleave', resetTilt);
    card.addEventListener('blur', resetTilt);
  });

  const updateCanvasQualityShowcase = (event) => {
    const imageUrl = event.detail?.imageUrl;
    if (!imageUrl) {
      console.warn(`${CANVAS_SHOWCASE_LOG_PREFIX} 收到更新事件，但缺少 imageUrl`);
      return;
    }

    const targets = document.querySelectorAll('[data-ai-generated-showcase], .canvas-quality__showcase-image');
    console.log(`${CANVAS_SHOWCASE_LOG_PREFIX} 收到预览替换事件`, {
      imageUrl,
      targetCount: targets.length,
      eventType: event.type || 'cached-value'
    });
    const preload = new Image();
    preload.onload = () => {
      targets.forEach((image) => {
        image.src = imageUrl;
        image.srcset = '';
        image.dataset.aiShowcaseSyncedUrl = imageUrl;
      });
      console.log(`${CANVAS_SHOWCASE_LOG_PREFIX} 新预览图加载完成，画框已替换`, {
        imageUrl,
        targetCount: targets.length
      });
    };
    preload.onerror = () => {
      console.error(`${CANVAS_SHOWCASE_LOG_PREFIX} 新预览图加载失败，保留当前画框图片`, { imageUrl });
    };
    preload.src = imageUrl;
  };

  document.addEventListener('ai-image:latest-generated', updateCanvasQualityShowcase);
  console.log(`${CANVAS_SHOWCASE_LOG_PREFIX} 监听器已注册`, {
    targetCount: document.querySelectorAll('[data-ai-generated-showcase], .canvas-quality__showcase-image').length,
    tiltTargetCount: canvasTiltCards.length,
    cachedImageUrl: window.latestAiGeneratedImageUrl || ''
  });

  if (window.latestAiGeneratedImageUrl) {
    updateCanvasQualityShowcase({
      type: 'cached-value',
      detail: { imageUrl: window.latestAiGeneratedImageUrl }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
